import {
  createPaymentColumns,
  useGetAllDeposits,
  withUserColumn,
} from '@entities/transaction';
import {ROUTE__DEPOSIT_FULL_INFO} from '@shared/constants';
import {AllPaymentsTab} from './AllPaymentsTab';

const columns = withUserColumn(
  createPaymentColumns(ROUTE__DEPOSIT_FULL_INFO, {showLocalAmount: true}),
);

export const AllDepositsTab = () => (
  <AllPaymentsTab
    useGetPayments={useGetAllDeposits}
    columns={columns}
    localStorageKey="allDepositsTable"
  />
);
